// extracted by mini-css-extract-plugin
export var container = "_je-0";
export var dotAnimation = "_je-2";
export var dotsLoading = "_je-1";